
// Extrai tenant_id do JWT token - evita conflito entre tenants
function getTenantIdFromToken() {
  try {
    const token = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
    if (!token) return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1"; }
}

import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import LandingPage from "./pages/LandingPage";
// AUD-T2b (28/10/2026) -- pagina publica de cadastro autonomo, destino dos
// anuncios. A landing continua intocada, para dar pra comparar as duas.
import Comecar from "./pages/Comecar";
import Dashboard from "./pages/Dashboard";
import OS from "./pages/OS";
import Estoque from "./pages/Estoque";
import Clientes from "./pages/Clientes";
import Financeiro from "./pages/Financeiro";
import Recuperados from "./pages/Recuperados";
import PrivateRoute from "./components/PrivateRoute";
import MeuPlano from "./pages/MeuPlano";
import Manual from "./pages/Manual";
import EsqueciSenha from "./pages/EsqueciSenha";
import RedefinirSenha from "./pages/RedefinirSenha";
import API_BASE from "./config";
import Orcamentos from "./pages/Orcamentos";
import OrcamentoDetalhe from "./pages/OrcamentoDetalhe";
import Agendamentos from "./pages/Agendamentos";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import TermosDeUso from "./pages/TermosDeUso";
import PoliticaCookies from "./pages/PoliticaCookies";
import { ChecklistApp } from "./checklist";
import { useNavigate, useSearchParams } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import ChecklistLicenseGate from "./components/ChecklistLicenseGate";
// AUD-A: o WorkshopProvider deixou de ser usado cru aqui. ChecklistConfigGate
// o envolve e injeta `config` a partir de oficina_config_<tenant>, que e como
// o painel administrativo controla recursos do checklist por oficina.
import ChecklistConfigGate from "./components/ChecklistConfigGate";
import { useTranslation } from "react-i18next";
import { isAuthenticated } from "./store/auth";
// Raiz do dominio: visitante anonimo ve a landing page publica (pensada
// pra divulgacao -- ver frontend/src/pages/LandingPage.js); quem ja tem
// sessao ativa vai direto pro Dashboard, sem passar pela landing.
function Home() {
  return isAuthenticated() ? <PrivateRoute><Dashboard /></PrivateRoute> : <LandingPage />;
}
function ChecklistDireto() {
  const [searchParams] = useSearchParams();
  const modoMobile = searchParams.get("modo") === "mobile";
  return (
    <ChecklistLicenseGate>
      <ChecklistConfigGate workshopId={getTenantIdFromToken()} workshopName={localStorage.getItem("tenant_nome") || "Oficina"}>
        <ChecklistApp modoMobile={modoMobile} />
      </ChecklistConfigGate>
    </ChecklistLicenseGate>
  );
}
function ChecklistPage() {
  const { t } = useTranslation();
  const tenantId = getTenantIdFromToken() || "1";
  const tenantNome = (sessionStorage.getItem("tenant_nome")||localStorage.getItem("tenant_nome")) || "Oficina";
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const modoMobile = searchParams.get("modo") === "mobile";
  return (
    <ChecklistLicenseGate>
      <div style={{ position: "relative" }}>
        <button
          onClick={() => navigate("/")}
          style={{
            position: "fixed", top: 10, right: 12, zIndex: 10000,
            background: "#1e293b", color: "#fff", border: "1px solid #334155",
            borderRadius: 6, padding: "5px 10px", fontSize: 11, fontWeight: 600,
            cursor: "pointer", display: "flex", alignItems: "center", gap: 4,
          }}
        >
          {t("checklist.voltar_ao_painel")}
        </button>
        <ChecklistConfigGate workshopId={tenantId} workshopName={tenantNome}>
          <ChecklistApp modoMobile={modoMobile} />
        </ChecklistConfigGate>
      </div>
    </ChecklistLicenseGate>
  );
}

async function syncPlano() {
  const tenantId = getTenantIdFromToken();
  if (!tenantId) return;
  const authToken = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"))||"";
  try {
    // GET /config/features_liberadas_tenant_X agora exige autenticacao
    // (ver auditoria de 11/08/2026).
    const rf = await fetch(API_BASE + "/api/v1/config/features_liberadas_tenant_" + tenantId, {
      headers: authToken ? { Authorization: "Bearer " + authToken } : {},
    });
    if (rf.ok) {
      const df = await rf.json();
      if (df.value && df.value.features) {
        localStorage.setItem("dev_features_liberadas_tenant_" + tenantId, JSON.stringify(df.value.features));
      }
    }
  } catch {}
  try {
    const rp = await fetch(API_BASE + "/api/v1/config/planos");
    if (rp.ok) {
      const dp = await rp.json();
      if (dp.value) localStorage.setItem("planos_config_central", JSON.stringify(dp.value));
    }
  } catch {}
  try {
    const token = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
    if (!token) return;
    const r = await fetch(API_BASE + "/api/v1/tenants/" + tenantId, {
      headers: { "Authorization": "Bearer " + token },
    });
    if (!r.ok) return;
    const td = await r.json();
    const planoAtual = (sessionStorage.getItem("plano")||localStorage.getItem("plano"));
    const planoNovo = (td.plan || "basico").toLowerCase();
    if (planoAtual !== planoNovo) {
      sessionStorage.setItem("plano", planoNovo);
      localStorage.setItem("tenant_nome", td.name || "");
      window.dispatchEvent(new CustomEvent("plano_atualizado", { detail: { plano: planoNovo } }));
    }
  } catch {}
  window.dispatchEvent(new CustomEvent("config_atualizado"));
}

export default function App() {
  useEffect(() => {
    // Correcao pontual -- "pisca" ao alternar entre abas: syncPlano() dispara
    // fetch de features/planos/tenant e, se algo mudou, os eventos
    // "plano_atualizado"/"config_atualizado" (Layout.js escuta o 2o e
    // reconstroi menu/tema). Antes isso rodava em TODO foco de janela --
    // quem ficava alternando abas via o painel "recarregar" a cada volta,
    // um blink visivel mesmo sem nenhum dado ter mudado de verdade. Agora so
    // roda no foco se fizer mais de 1 minuto desde a ultima sincronizacao
    // (o setInterval de 2 em 2 min continua garantindo dado fresco de toda
    // forma).
    let ultimoSync = 0;
    const SYNC_MIN_INTERVAL_MS = 60 * 1000;
    const rodar = () => { ultimoSync = Date.now(); syncPlano(); };
    rodar();
    const interval = setInterval(rodar, 2 * 60 * 1000);
    const onFocus = () => { if (Date.now() - ultimoSync >= SYNC_MIN_INTERVAL_MS) rodar(); };
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  return (
    <ErrorBoundary>
    <Routes>
      <Route path="/login"           element={<Login />} />
      {/* AUD-T2b -- PUBLICA, sem PrivateRoute: quem chega aqui ainda nao
          tem conta. Precisa estar declarada: o caminho curinga no fim do
          arquivo redireciona tudo que nao casa para "/", entao /comecar
          sem rota levaria a pessoa para a landing em silencio, sem 404 e
          sem erro no log. */}
      <Route path="/comecar"         element={<Comecar />} />
      <Route path="/esqueci-senha"   element={<EsqueciSenha />} />
      <Route path="/redefinir-senha" element={<RedefinirSenha />} />
      <Route path="/"                element={<Home />} />
      <Route path="/orcamentos" element={<PrivateRoute><Orcamentos /></PrivateRoute>} />
      <Route path="/orcamentos/:osId" element={<PrivateRoute><OrcamentoDetalhe /></PrivateRoute>} />
      <Route path="/os"              element={<PrivateRoute><OS /></PrivateRoute>} />
      <Route path="/estoque"         element={<PrivateRoute><Estoque /></PrivateRoute>} />
      <Route path="/clientes"        element={<PrivateRoute><Clientes /></PrivateRoute>} />
      <Route path="/agendamentos"    element={<PrivateRoute><Agendamentos /></PrivateRoute>} />
      <Route path="/financeiro"      element={<PrivateRoute><Financeiro /></PrivateRoute>} />
      {/* Arquivo do que foi excluido -- ver pages/Recuperados.js. */}
      <Route path="/recuperados"     element={<PrivateRoute><Recuperados /></PrivateRoute>} />
      <Route path="/checklist"       element={<PrivateRoute><ChecklistDireto /></PrivateRoute>} />
      <Route path="/manual"          element={<PrivateRoute><Manual /></PrivateRoute>} />
      <Route path="/checklist/*"     element={<PrivateRoute><ChecklistPage /></PrivateRoute>} />
      <Route path="/meu-plano"       element={<PrivateRoute><MeuPlano /></PrivateRoute>} />
      <Route path="/privacidade"     element={<PoliticaPrivacidade />} />
      <Route path="/termos"          element={<TermosDeUso />} />
      <Route path="/cookies"         element={<PoliticaCookies />} />
      <Route path="*"                element={<Navigate to="/" />} />
    </Routes>
    </ErrorBoundary>
  );
}
